import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import EditStoreComp from '../../components/version-4/MasterForms/EditForms/EditStoreComp'
import StoreFormComp from '../../components/version-4/MasterForms/StoreFormComp'
import { useStore } from '../../hooks/CompanyConfiguration/useStore'
import { ROUTES } from '../../shared/constants'
import StoreForm from '../Masters/StoreForm'
function EditStore() {
  const { store, getStore, updateStore } = useStore()
  const params = useParams()

  const [storedata, setStoreData] = useState({
    name: '',
    region: '',
    zone: '',
    state1: '',
    district1: '',
  })

  React.useEffect(() => {
    getStore({ storeId: params.storeId })
  }, [params.storeId])

  React.useEffect(() => {
    setStoreData({
      name: store.name,
      region: store.region,
      zone: store.zone,
      state1: store.state,
      district1: store.district,
    })
  }, [store])

  const handleStore = () => {
    updateStore({
      name: storedata.name,
      region: storedata.region,
      zone: storedata.zone,
      state: storedata.state1,
      district: storedata.district1,
    })
  }
  return <>{store ? <StoreForm store={store} /> : <Loader />}</>
}

export default EditStore
